<template>
    <div v-if="slider && slider.value" class="v-range-slider">
        <div class="v-range-slider__top">
            <div class="v-range-slider__label">
                <span>от</span>
                <input readonly type="text" :value="formatPrice(slider.value[0])">
            </div>

            <div class="v-range-slider__label">
                <span>до</span>
                <input readonly type="text" :value="formatPrice(slider.value[1])">
            </div>
        </div>

        <VueSlider v-model="slider.value"
                   :min="slider.min"
                   :max="slider.max"
                   :minRange="slider.minRange"
                   :maxRange="slider.maxRange"
                   :interval="1000" @change="change" />
    </div>
</template>

<script>
import 'vue-slider-component/theme/default.css';
import VueSlider from 'vue-slider-component';

export default {
    props: ['slider', 'name'],

    components: {
        VueSlider
    },
    computed: {

    },
    methods: {
        change() {
            this.$emit('change', this.slider);
        },

        reset() {
            this.slider.value = [this.slider.min, this.slider.max];
        },

        formatPrice(value) {
            const val = (value / 1).toFixed(0).replace('.', ',');

            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }
    },
    mounted() {
        if (this.slider) {
            this.$set(this.slider, 'value', [this.slider.from, this.slider.to]);
        }
    }
};
</script>
